import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MenuItemModel } from '../views/models/menu-item.model';
import { MenuItemCatalogModel } from '../views/models/menu-item-catalog.model';
import { MenuItemCatalogGroupModel } from '../views/models/menu-item-catalog-group.model';
import { MenuAttachmentModel } from '../views/models/menu-attachment.model';
import { MenuItemCatalogPriceModel } from '../views/models/menu-item-catalog-price.model';
import { MenuTagModel } from '../views/models/menu-tag.model';
import { UserService } from './user.service';
import { environment } from '../../environments/environment';

export class CatalogCategory {
  category: MenuItemCatalogGroupModel;
  items: MenuItemCatalogModel[];
  display?: boolean;
  edit?: boolean;

  constructor(
    category = new MenuItemCatalogGroupModel(),
    items = []
  ) {
    this.category = category;
    this.items = items;
  }
}

@Injectable()
export class CatalogueService {
  datas = [];
  record_change$: BehaviorSubject<CatalogCategory[]> = new BehaviorSubject<CatalogCategory[]>(this.datas);
  price_change$ = new BehaviorSubject<MenuItemCatalogPriceModel[]>([]);
  /*  PriceDatas kullanuldığı zaman popup açılıp data çekildiğinde price datası değişiyordu. Bunun için Popuplarda kullanulacak priceDetailDatas oluşturulmuştur. */
  priceDetail_change$ = new BehaviorSubject<MenuItemCatalogPriceModel[]>([]);
  modifiers = new BehaviorSubject<MenuItemCatalogPriceModel[]>([]);
  pdf_change$ = new BehaviorSubject<MenuAttachmentModel[]>([]);
  tag_change$ = new BehaviorSubject<MenuTagModel[]>([]);
  dialag_change$ = new BehaviorSubject<MenuItemModel[]>([]);

  lastGroup: number = null;
  lastEdit: number = null;
  menuItemId: number = null;

  constructor(
    private httpClient: HttpClient,
    private userService: UserService
  ) {
  }

  getData(itemId: number): Promise<CatalogCategory[]> {
    return new Promise((resolve) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/catalog_group/' + itemId).subscribe(
        (catalog: MenuItemCatalogGroupModel[]) => {
          if (catalog.length == 0) {
            this.record_change$.next([]);
            return;
          }
          this.httpClient.get(environment.baseURL + '/v2/api' + '/catalog/' + itemId).subscribe(
            (datas: MenuItemCatalogModel[]) => {
              this.httpClient.get(environment.baseURL + '/v2/api' + '/catalog_price/' + itemId).subscribe(
                (prices: MenuItemCatalogPriceModel[]) => {
                  this.price_change$.next(prices);
                  const record_datas: CatalogCategory[] = [];
                  for (const menuCategoryData of catalog) {
                    const data = new CatalogCategory();
                    data.category = menuCategoryData;
                    data.items = datas.filter(x => x.menu_item_catalog_group_id == menuCategoryData.id);
                    data.items = data.items.sort((a, b) => a.priority - b.priority);
                    data.display = this.lastGroup === data.category.id ? true : false;
                    data.edit = this.lastEdit === data.category.id ? true : false;
                    record_datas.push(data);
                  }
                  this.record_change$.next(record_datas);
                  resolve(record_datas);
                }
              );
            }
          );
        }
      );
      this.httpClient.get('./assets/DefaultItems.json').subscribe(
        (datas: any[]) => {
          this.dialag_change$.next(datas);
        }
      );
    })
  }

  getDataPromise(id: number): Promise<MenuItemCatalogGroupModel[]> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/catalog_group/' + id).subscribe(
        (catalog: MenuItemCatalogGroupModel[]) => {
          if (catalog.length == 0) {
            this.record_change$.next([]);
            return;
          } else {
            resolve(catalog);
          }
        }
      );
    });
  }

  getCatalogTags(tableRecordId: number) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_tag/menu-item-catalog/' + tableRecordId).subscribe(
      (datas: MenuTagModel[]) => {
        this.tag_change$.next(datas);
      }
    );
  }

  postTagData(data: MenuTagModel) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_tag', data).subscribe(
      () => {
      },
      error => console.log(error),
      () => this.getCatalogTags(data.table_record_id)
    );
  }

  putCatalogData(data: MenuItemCatalogModel) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/catalog/' + data.id, data).subscribe(
      () => {
      },
      error => console.log(error)
    );
  }

  deleteCatalogData(data: MenuItemCatalogModel) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/catalog/' + data.id).subscribe(
      () => {
      },
      (error) => {
        console.log(error);
      },
      () => {
        this.getData(data.menu_item_id);
      }
    );
  }

  setDatas(datas: CatalogCategory[]) {
    this.datas = datas;
    for (const item of this.datas) {
      item.items = item.items.sort((a, b) => a.priority - b.priority);
    }
    this.record_change$.next(this.datas);
  }

  setPriceDetailDatas(datas: MenuItemCatalogPriceModel[]) {
    this.priceDetail_change$.next(datas);
  }

  getCatalogPrice(menuItemID: number, catalogID: number) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/catalog_price/' + menuItemID).subscribe(
      (datas: MenuItemCatalogPriceModel[]) => {
        this.priceDetail_change$.next(datas.filter(x => x.menu_item_catalog_id == catalogID && !x.is_modifier));
        this.modifiers.next(datas.filter(x => x.menu_item_catalog_id == catalogID && x.is_modifier));
      }
    );
  }

  deleteCatalogPrice(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.httpClient.delete(environment.baseURL + '/v2/api' + '/catalog_price/' + id).subscribe(
        () => {
          resolve(true);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Catalog menüsünde pdf kayıtlarında değişiklik durumunda çalışacak.
  putPdf(data: MenuAttachmentModel, NoRefresh?: boolean) {
    if (NoRefresh == undefined) {
      NoRefresh = false;
    }
    console.log('NoRefresh : ', NoRefresh);
    this.httpClient.put(environment.baseURL + '/v2/api' + '/menu_attachment/' + data.id, data).subscribe(
      () => {
      },
      error => console.log(error),
      () => {
        if (!NoRefresh) {
          this.getData(data.table_record_id);
        }
      }
    );
  }

  postFile(selectedFile: File) {
    const attachment: MenuAttachmentModel = new MenuAttachmentModel();
    const fd = new FormData();
    fd.append('file', selectedFile, selectedFile.name);
    this.httpClient.post(environment.baseURL + '/v2/api' + '/uploaddocument?bucketname=b1development&directory=icibotV2/' + this.userService.record_change$.getValue().app_hotel_id + '/', fd)
      .subscribe((data: any) => {
        attachment.attachment_url = data.link;
        attachment.name = selectedFile.name;
        this.postAttachment(attachment);
      },
        (err) => {
          console.log('Err : ' + err);
        }
      );
  }

  postAttachment(data: MenuAttachmentModel) {
    data.table_name = 'item-catalog-pdf';
    data.type = 'pdf';
    data.table_record_id = this.pdf_change$.getValue()[0].table_record_id;
    const datas = [data];
    this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_attachment', datas).subscribe(
      () => {
      },
      error => console.log(error),
      () => {
        this.getData(data.table_record_id);
      });
  }

  deleteAttachment(item: MenuAttachmentModel) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/menu_attachment/' + item.id).subscribe((data: any) => {
    },
      (err) => console.log(err),
      () => {
        this.httpClient.delete(environment.baseURL + '/v2/api' + '/uploaddocument?bucketname=b1development&directory=icibotV2/' + this.userService.record_change$.getValue().app_hotel_id + '/' + item.name)
          .subscribe(() => {
          },
            (err) => {
              console.log('Err : ' + err);
            }
          );
      });
  }

  putPriceData(data: MenuItemCatalogPriceModel) {
    data.price = +data.price;
    data.offer_price = +data.offer_price;
    this.httpClient.put(environment.baseURL + '/v2/api' + '/catalog_price/' + data.id, data).subscribe(
      () => {
      },
      (error) => console.log(error),
      () => this.getData(data.menu_item_id)
    );
  }

  postCatalogGroup(data: MenuItemCatalogGroupModel) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(environment.baseURL + '/v2/api' + '/catalog_group', data).subscribe(
        () => {
          resolve(true);
        },
        (error) => {
          console.log(error);
        },
        () => {
          this.getData(data.menu_item_id);
        });
    })

  }

  putCatalogGroup(data: MenuItemCatalogGroupModel) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/catalog_group/' + data.id, data).subscribe(
      () => {
      },
      (error) => {
        console.log(error);
      });
  }

  deleteCatalogGroup(data: MenuItemCatalogGroupModel) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/catalog_group/' + data.id).subscribe(
      () => {
      },
      (err) => {
        console.log(err);
      },
      () => this.getData(data.menu_item_id)
    );
  }

  postData(data: MenuItemCatalogModel) {
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/catalog', data);
  }

  postCatalog(data: MenuItemCatalogModel): Promise<MenuItemCatalogModel> {
    return new Promise((resolve, reject) => {
      this.httpClient.post(environment.baseURL + '/v2/api' + '/catalog', data).subscribe({
        next: (resp: MenuItemCatalogModel) => {
          resolve(resp);
        },
        error: err => {
          reject(err);
        }
      });
    });
  }

  postPrice(data: MenuItemCatalogPriceModel): Promise<MenuItemCatalogPriceModel> {
    return new Promise((resolve, reject) => {
      this.httpClient.post(environment.baseURL + '/v2/api' + '/catalog_price', data).subscribe({
        next: (resp: MenuItemCatalogPriceModel) => {
          resolve(resp);
        },
        error: err => {
          reject(err);
        }
      });
    });
  }

  postPriceData(data: MenuItemCatalogPriceModel) {
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/catalog_price', data);
  }

}

